import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { styled as materialStyled } from "@mui/material/styles";
import { OpenInNewRounded } from "@mui/icons-material";

export const FactSheetLink = React.forwardRef(({ children, fundName, isin, ...rest }, ref) => {
    return (
        <StyledLink
            ref={ref}
            {...rest}
            target="_blank"
            rel="noopener noreferrer"
            href={`https://digital.feprecisionplus.com/factsheethtml/nucleusfinancial/en-GB/Nucleus-New/?ISINCode=${isin}`}
            aria-label={`fund fact sheet for ${fundName}`}
        >
            {children}
        </StyledLink>
    );
});

export const LinkText = styled.span`
    margin-right: 10px;
    line-height: 1rem;
`;

export const OpenIcon = materialStyled(OpenInNewRounded)({
    fontSize: 16
});

const StyledLink = styled.a`
    color: inherit;
    display: flex;
    align-items: center;
`;

FactSheetLink.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.node]),
    isin: PropTypes.string,
    fundName: PropTypes.string
};
